/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Vessel } from '../../../models/vessels/vessel.model';
import {
  defaultValues,
  NearbyVesselsFormValues,
} from './nearby-vessels-form/nearby-vessels-form-values';

interface NearbyVesselsState {
  vessels: Vessel[] | null;
  formValues: NearbyVesselsFormValues;
  loading: boolean;
  error: boolean;
}

const initialState: NearbyVesselsState = {
  vessels: null,
  formValues: defaultValues,
  loading: false,
  error: false,
};

const nearbyVesselsSlice = createSlice({
  name: 'nearbyVessels',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setVessels: (state, action: PayloadAction<Vessel[] | null>) => {
      state.vessels = action.payload;
      state.loading = false;
      state.error = false;
    },
    setFormValues: (
      state,
      action: PayloadAction<Partial<NearbyVesselsFormValues>>
    ) => {
      state.formValues = { ...state.formValues, ...action.payload };
    },
    appendVessels: (state, action: PayloadAction<Vessel[]>) => {
      if (!action.payload.length) return;
      // Merge into existing list, with incoming data winning on vessel_id collision.
      const vesselMap = new Map<string, Vessel>(
        (state.vessels ?? []).map((v) => [v.vessel_id, v])
      );
      action.payload.forEach((v) => vesselMap.set(v.vessel_id, v));
      state.vessels = Array.from(vesselMap.values());
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setLoading,
  setVessels,
  setFormValues,
  appendVessels,
  setError,
} = nearbyVesselsSlice.actions;

export default nearbyVesselsSlice.reducer;
